module.exports = __webpack_public_path__ + "static/img/xzapp.4cb5bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xzapp.png
// module id = /L4r
// module chunks = 4